module.exports = __webpack_public_path__ + "static/quality-8117437b442edbc82187c0a61dbfeb4e.png";